import React from 'react';
import styled from 'styled-components';
import { Modal } from 'reactstrap';
import { media, onlyIf } from '../../helpers/responsive';

const StyledModal = styled(Modal)`
    font-family: 'Montserrat', tahoma !important;

    .modal-header {
        .btn-close::after {
            color: white !important;
            text-shadow: unset !important;
        }
    }

    ${media.mobile`
        .modal-title {
            font-size: 14px !important;
        }
        .modal-footer button {
            font-size: 12px !important;
        }
    `};

    ${(props) => onlyIf(props.size === 'xl')`
        max-width: 950px;
        width: 100%;
    `}
`;

const OpusModal = ({ modalName, wrapClassName, ...props }) => (
    <StyledModal
        {...props}
        wrapClassName={`modal-primary modal-${modalName} ${wrapClassName}`}
    />
);

export default OpusModal;
